"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MOCK_CART_ITEM_VOIP_NEW = exports.MOCK_CART_ITEM_VOIP_PORT = void 0;
const index_1 = require("../../constants/index");
const index_2 = require("../../generated-source/api/index");
exports.MOCK_CART_ITEM_VOIP_PORT = {
    productDiscounts: [],
    sku: '14x13858886',
    cartItemId: '11844',
    additionalData: {
        parentCartItemId: '11843',
        parentSku: '14x14612990',
        productCategory: index_2.ProductCategory.Voip,
        productQualification: null,
        productConfiguration: {
            orderType: index_1.VoipOrderType.Port,
            serviceNumber: '02 1234 5678',
            losingProvider: 'Telstra',
            portingAccountNumber: '0123456789',
        },
        productDisplayAttributes: {
            productName: 'Home Phone Test 1 VoIP',
            price: '11',
        },
    },
};
exports.MOCK_CART_ITEM_VOIP_NEW = {
    productDiscounts: [],
    sku: '14x13858888',
    cartItemId: '11845',
    additionalData: {
        parentCartItemId: '11843',
        parentSku: '14x14612990',
        productCategory: 'Voip',
        productQualification: null,
        productConfiguration: {
            orderType: index_1.VoipOrderType.New,
            serviceNumber: '02 8765 4321',
        },
        productDisplayAttributes: {
            productName: 'Home Phone Test 2 VoIP',
            price: '11',
        },
    },
};
//# sourceMappingURL=cart-item-voip.mock.js.map